import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/global.css';
import './responsive.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Respect user's theme via TopNavigation toggle; no forced theme here

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
